module.exports = "<button class=\"zui-button button-comp\" [disabled]=\"disabled\" [ngClass]=\"{'full-width': fullWidth, 'floating': floating, 'big': big, 'flat': flat}\">\n  <ng-content></ng-content>\n  <span class=\"icon\" [ngClass]=\"prefixIcon\" *ngIf=\"prefixIcon\"></span>{{floating ? '' : label}}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/button/button.html
// module id = ./src/app/components/button/button.html
// module chunks = main